var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBackToTopinline = function SvgBackToTopinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 24c0 7.467-2.349 13.328-6.427 17.323C36.993 45.32 31.128 47.5 24 47.5s-12.992-2.18-17.073-6.177C2.85 37.328.5 31.467.5 24c0-7.467 2.349-13.329 6.427-17.323C11.007 2.68 16.872.5 24 .5s12.992 2.18 17.073 6.177C45.15 10.672 47.5 16.533 47.5 24Z",
    stroke: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 34a1 1 0 0 1-1-1V15a1 1 0 1 1 2 0v18a1 1 0 0 1-1 1Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.707 21.707a1 1 0 0 1-1.414 0L24 16.414l-5.293 5.293a1 1 0 0 1-1.414-1.414l6-6a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414Z",
    fill: "#fff"
  })));
};

export default SvgBackToTopinline;